import { render, staticRenderFns } from "./PendenciesUploadList.vue?vue&type=template&id=3997ff41"
import script from "./PendenciesUploadList.vue?vue&type=script&lang=js"
export * from "./PendenciesUploadList.vue?vue&type=script&lang=js"
import style0 from "./PendenciesUploadList.vue?vue&type=style&index=0&id=3997ff41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports